module.exports = __webpack_public_path__ + "static/media/lafourchette-5.fd88970d.png";